// extracted by mini-css-extract-plugin
module.exports = {"mappingoption":"MappingProperties_mappingoption__1WhkN","propertiesselect":"MappingProperties_propertiesselect__19C7y","switch":"MappingProperties_switch__3yQ5j"};